// extracted by mini-css-extract-plugin
module.exports = {"currentColor":"ColorChooser_currentColor__kJ_Fk","colorButtons":"ColorChooser_colorButtons__OICKh","colorButton":"ColorChooser_colorButton__1ac4H"};